// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_4cb8fb11"};